import Jumbotron from "components/Jumbotron";
import { SubmitButton } from "features/payment/paymentPageStyles";
import React, { useRef } from "react";
import { useForm } from "react-hook-form";
import styled from "styled-components/macro";
import { device, toRem } from "theme/Breakpoints";
import { DefaultText } from "theme/GlobalElements";
import { colors } from "theme/Theme";
import { useDispatch } from "react-redux";
import { subscribe } from "features/admin/EmailSender/emailSenderSlice";

interface SubscribeProps {}

const Subscribe: React.FC<SubscribeProps> = ({}) => {
  const { register, control, handleSubmit, errors } = useForm();
  const dispatch = useDispatch();

  const onFormSubmit = async (data: any) => {
    if (!data.emailFake) {
      dispatch(subscribe(data));
    }
  };

  return (
    <Jumbotron>
      <h3>Абонирайте се</h3>
      <InputContainer onSubmit={handleSubmit(onFormSubmit)}>
        <Input
          className="text-body"
          name="names"
          ref={register({ required: true })}
          placeholder="* Вашите имена"
          required={true}
        />
        <Input
          className="text-body"
          type="email"
          name="email"
          ref={register({
            required: true,
            pattern: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
          })}
          placeholder="* Имейл адрес"
        />
        <Input
          className="text-body"
          name="emailFake"
          style={{ display: "none" }}
        />
        <SubmitButton
          className="submit-button text-body"
          type="submit"
          value="Изпрати"
        />
      </InputContainer>
      <AdditionalTexts>
        <AdditionalText className="text-sm">
          * Абонирайте се за промоционални оферти
        </AdditionalText>
        <AdditionalText className="text-sm">
          * Получаване на ексклузивни промо кодове
        </AdditionalText>
      </AdditionalTexts>
    </Jumbotron>
  );
};

const InputContainer = styled.form`
  margin: 12px 0;
  display: flex;
  flex-direction: column;
  width: 100%;

  .submit-button {
    border-radius: 5px;
    margin-top: 12px;

    @media only screen and (${device.laptop}) {
      flex: 0 19%;
      margin-top: 0;
    }
  }

  @media only screen and (${device.laptop}) {
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
  }
`;
InputContainer.displayName = "InputContainer";

const Input = styled.input`
  font-size: 16px;
  flex: 1 100%;
  background-color: white;
  border-radius: 5px;
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid ${colors.dark_gray};

  & + & {
    margin-top: 12px;
  }

  @media only screen and (${device.laptop}) {
    flex: 0 39%;

    & + & {
      margin-top: 0;
    }
  }
`;
Input.displayName = "Input";

const AdditionalTexts = styled.div`
  margin-top: 12px;
`;

const AdditionalText = styled(DefaultText)`
  & + & {
    margin-top: 5px;
  }
`;

export default Subscribe;
